import { render, staticRenderFns } from "./QuizItemDebug.vue?vue&type=template&id=02d229d3&scoped=true&"
import script from "./QuizItemDebug.vue?vue&type=script&lang=js&"
export * from "./QuizItemDebug.vue?vue&type=script&lang=js&"
import style0 from "./QuizItemDebug.vue?vue&type=style&index=0&id=02d229d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d229d3",
  null
  
)

export default component.exports